import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input, Label } from "../../../styles";
import SettingsWrapper from "../../../layout/SettingsWrapper";
import { useUserContext } from "../../../context/user_context";
import Api from "../../../api/axios";

function StoreProfile() {

  const [issending, setissending] = useState(false);

  const { storeData, getStoreData, btoken, stoken } = useUserContext();

  const {
    storename
    , location
  } = storeData;

  const [formField, setformField] = useState({
    storename
    , location
  });

  // Form Fields
  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Field

  // Edit Function 
  const [editData, seteditData] = useState(true);

  function onEdit() {
    seteditData(false);
    if (editData === true) {
      toast.success('You can now edit...');
    } else { }
  }
  // Edit Function 

  function submitFn(e) {
    e.preventDefault();
    if ((formField.storename
      && formField.location
    )) {
      setissending(true);
      const data = {
        name: formField.storename,
        location: formField.location,
        btoken, stoken
      };
      Api.post(`/updateStore`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            seteditData(true);
            getStoreData();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }


  return (
    <>
      <SettingsWrapper
        title="STORE PROFILE"
        onEdit={onEdit}
      >
        <div className="d-flex flex-wrap gap-2 mt-4 ">

          <h6 className="pry-text sec fit-content br-sm p-2">
            Store ID: <span className="fw-bold"> {stoken}</span>
          </h6>
        </div>

        <Form onSubmit={(e) => submitFn(e)}>

          <div className="row justify-content-center">
            <div className="col-md-6 ">
              <Label> Store Name: </Label>
              <Input
                type="text"
                name="storename"
                placeholder="Enter Name"
                onChange={handleChange}
                value={formField.storename}
                required
                disabled={editData ? true : false}
              />
            </div>

            <div className="col-md-6 ">
              <Label> Store Location: </Label>
              <Input
                type="text"
                name="location"
                placeholder="Enter Location"
                onChange={handleChange}
                value={formField.location}
                required
                disabled={editData ? true : false}
              />
            </div>
            {!editData &&
              <div className="col-md-12 mb-4 mx-auto text-center">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            }
          </div>
        </Form>
      </SettingsWrapper>

      {/* {load ? <AppLoader /> : <></>} */}

    </>
  );
}

export default StoreProfile;
